import AssetsMain from '@/assets/image/useCases/privateCredit/assets_main.png'
import '@/assets/scss/global.scss';
import './index.scss'
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

const PrivateCreditHead = () => {
  const isDesktop = useMediaQuery({ minWidth: 769 });
   return (
     <div className={`w-1340 private-credit-head ${isDesktop?`pt-[120px] pb-[120px]`:`pt-[80px] pb-[80px]`}`}>
       {
         isDesktop ? (
           <div className={`flex items-center`}>
             <div className={`text-[#fff] text-left flex-1 mr-[32px]`}>
               <div className={`private-credit-head-title text-[64px]`}>On-Chain Private Credit</div>
               <div className={`get-touch-btn mt-[74px]`}>
                 <Link target="_blank" to="https://form.typeform.com/to/IjCOn4nY?typeform-source=vishwanetwork.xyz">
                   <div className={`get-touch-btn-text`}>Get In Touch</div>
                 </Link>
                 <div className={`get-touch-mask`} />
               </div>
             </div>
             <div className={`flex items-center`}>
               <img src={AssetsMain} className={`h-[413px]`} />
             </div>
           </div>
         ) : (
           <div className={`text-center`}>
             <div className={`flex items-center`}>
               <img src={AssetsMain} className={`w-[80%] ml-[10%]`} />
             </div>
             <div className={`text-[#fff] text-center flex-1 mt-[32px]`}>
               <div className={`private-credit-head-title text-[20px]`}>On-Chain Private Credit</div>
               <div className={`get-touch-btn mt-[20px]`} style={{ margin: '20px auto' }}>
                 <Link target="_blank" to="https://form.typeform.com/to/IjCOn4nY?typeform-source=vishwanetwork.xyz">
                   <div className={`get-touch-btn-text`}>Get In Touch</div>
                 </Link>
                 <div className={`get-touch-mask`} />
               </div>
             </div>
           </div>
         )
       }
     </div>
   )
}

export default PrivateCreditHead